import { getDefaultSPPageContext } from './getDefaultSPPageContext';
import { PeoplePickerProvider } from '@ms/odsp-datasources/lib/providers/peoplePicker/odb/PeoplePickerProvider';

export async function getDefaultPeoplePickerProvider(webUrl: string) {
    const spPageContext = await getDefaultSPPageContext(webUrl);

    const peoplePickerProvider = new PeoplePickerProvider({
        pageContext: spPageContext,
    });

    return peoplePickerProvider;
}
